import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultOrderPaymentFormAssets = {
    orderCompletionFailedIconName: 'payment-error-message',
    paymentFailedIconName: 'payment-error-message',
    paymentDeclinedIconName: 'payment-error-message',
    failedToInitialiseConnectorIconName: 'payment-error-message',
    failedToLoadDataIconName: 'payment-error-message',
    removePaymentButtonIconName: 'trash',
    removePaymentLoadingIconName: 'spinner',
    failedToRemovePaymentIconName: 'warning-circle',
    connectorLoadingIconName: 'spinner',
    processingPaymentIconName: 'spinner'
};
export const orderPaymentFormAssetsValidator = Validator.object({
    orderCompletionFailedIconName: nonEmptyStringValidator,
    paymentFailedIconName: nonEmptyStringValidator,
    paymentDeclinedIconName: nonEmptyStringValidator,
    failedToInitialiseConnectorIconName: nonEmptyStringValidator,
    failedToLoadDataIconName: nonEmptyStringValidator,
    removePaymentButtonIconName: nonEmptyStringValidator,
    removePaymentLoadingIconName: nonEmptyStringValidator,
    failedToRemovePaymentIconName: nonEmptyStringValidator,
    connectorLoadingIconName: nonEmptyStringValidator,
    processingPaymentIconName: nonEmptyStringValidator
});
